/* Khizra storefront search engine (2026-10-05).
   Shared by the search popup (snippets/search-overlay.liquid) and the search page (sections/main-search.liquid).
   Reads the product index from /search?view=index (templates/search.index.liquid) and ranks products in the browser:
   word variants (3 piece / three-piece / 3pc), plurals, colour families (maroon = red ...), seasons, "sale", a few Urdu colour words,
   prefixes as you type (one letter is enough) and typo tolerance. Sold-out styles always come last. All matching words must be found; if none are, the closest partial matches are returned. */
(function () {
  'use strict';
  if (window.KhizraSearch) return;
  var themeId = '';
  try { themeId = String((window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || ''); } catch (e) {}
  var KEY = 'khizra_search_catalog_v1_' + themeId, TTL = 10 * 60 * 1000, cat = null, pend = null;

  function set(s) { var o = {}; s.split(' ').forEach(function (w) { if (w) o[w] = 1; }); return o; }
  var STOP = set('suit suits suite dress dresses women womens woman ladies lady stitched ready wear to for the and in with of a an by set sets shirt shirts kurta kurti kameez qameez trouser trousers shalwar salwar pants pant bottom bottoms top piece pieces pc pcs please show me');
  var ALIAS = {
    embroidery: 'embroidered', embroider: 'embroidered', embroidred: 'embroidered', emb: 'embroidered',
    print: 'printed', prints: 'printed', dupata: 'dupatta', dupattas: 'dupatta', fall: 'autumn', autum: 'autumn', latest: 'new',
    kala: 'black', kaala: 'black', safed: 'white', gulabi: 'pink', hara: 'green', sabz: 'green', neela: 'blue', neeli: 'blue',
    lal: 'red', surkh: 'red', peela: 'yellow', jamni: 'purple', discount: 'sale', offer: 'sale', off: 'sale', deal: 'sale', deals: 'sale'
  };
  var EXTRA = {
    maroon: ['red'], burgundy: ['red', 'wine'], wine: ['red'], navy: ['blue'], teal: ['blue', 'green'], lavender: ['purple', 'lilac'],
    magenta: ['pink'], pistachio: ['green'], olive: ['green'], sage: ['green'], beige: ['cream', 'nude'], brown: ['coffee', 'chocolate'],
    pink: ['rose'], yellow: ['mustard']
  };
  var COLL_ALIAS = { 'autumns-cotton-edit': 'new fall autumn', 'summers-archive': 'summer' };

  function norm(s) {
    s = String(s == null ? '' : s).toLowerCase().replace(/&/g, ' and ').replace(/['’`]/g, '');
    s = s.replace(/\bone\b/g, '1').replace(/\btwo\b/g, '2').replace(/\bthree\b/g, '3');
    s = s.replace(/(\d)\s*[- ]?\s*(pieces?|pcs?)\b/g, '$1 piece');
    s = s.replace(/(\d)([a-z])/g, '$1 $2').replace(/([a-z])(\d)/g, '$1 $2');
    return s.replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function stem(t) { return t.length > 3 && t.charAt(t.length - 1) === 's' && t.charAt(t.length - 2) !== 's' ? t.slice(0, -1) : t; }
  function canon(t) { t = ALIAS[t] || t; t = stem(t); return ALIAS[t] || t; }
  function words(s, keepNums) {
    var out = [], a = norm(s);
    if (!a) return out;
    a.split(' ').forEach(function (t) {
      t = canon(t);
      if (!t || STOP[t]) return;
      if (!keepNums && /^\d+$/.test(t)) return;
      out.push(t);
    });
    return out;
  }
  function lev(a, b) {
    var m = a.length, n = b.length, p = [], i, j;
    if (!m) return n; if (!n) return m;
    for (j = 0; j <= n; j++) p[j] = j;
    for (i = 1; i <= m; i++) {
      var prev = p[0]; p[0] = i;
      for (j = 1; j <= n; j++) {
        var tmp = p[j];
        p[j] = Math.min(p[j] + 1, p[j - 1] + 1, prev + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
        prev = tmp;
      }
    }
    return p[n];
  }
  function tm(q, c, isTitle) {
    if (q === c) return 1;
    if (q.length < c.length && c.indexOf(q) === 0 && q.length >= (isTitle ? 1 : 2)) return 0.85;
    if (q.length >= 4 && c.length >= 4 && Math.abs(q.length - c.length) <= (q.length >= 9 ? 3 : 2)) {
      var lim = q.length >= 9 ? 3 : (q.length >= 7 ? 2 : 1);
      if (lev(q, c) <= lim) return 0.55;
    }
    return 0;
  }

  function prep(d) {
    d.products.forEach(function (p) {
      var f = [];
      function add(str, w, title) {
        words(str).forEach(function (t) {
          f.push([t, w, !!title]);
          (EXTRA[t] || []).forEach(function (x) { f.push([x, w - 1, false]); });
        });
      }
      add(p.t, 10, true); add(p.col, 8); add(p.f, 7); add(p.tf, 5); add(p.df, 5); add(p.w, 6); add(p.ty, 5); add(p.se, 6);
      (p.tg || []).forEach(function (t) { add(t, 4); });
      (p.cl || []).forEach(function (h) { add(COLL_ALIAS[h] || '', 5); });
      if (p.c > p.p) add('sale', 4);
      if (p.pc === 3) add('dupatta', 6);
      p._f = f;
      p._t = norm(p.t);
      p.disc = p.c > p.p ? (p.c - p.p) / p.c : 0;
    });
    d.collections.forEach(function (c) {
      c._w = words(c.t).concat(words(COLL_ALIAS[c.h] || ''));
    });
    return d;
  }

  function load() {
    if (cat) return Promise.resolve(cat);
    if (pend) return pend;
    try {
      var raw = sessionStorage.getItem(KEY);
      if (raw) { var o = JSON.parse(raw); if (o && o.d && o.d.products && Date.now() - o.t < TTL) { cat = prep(o.d); return Promise.resolve(cat); } }
    } catch (e) {}
    pend = fetch('/search?view=index', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        var a = t.indexOf('<!--KZ-->'), b = t.indexOf('<!--/KZ-->');
        if (a < 0 || b < 0) throw new Error('bad index');
        var d = JSON.parse(t.slice(a + 9, b));
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        cat = prep(d);
        return cat;
      })
      .catch(function (e) { pend = null; throw e; });
    return pend;
  }

  function parse(q) {
    var n = norm(q), toks = n ? n.split(' ') : [], pieces = null, rest = [], i, t;
    for (i = 0; i < toks.length; i++) {
      t = toks[i];
      if (/^[23]$/.test(t)) { pieces = +t; if (toks[i + 1] === 'piece') i++; continue; }
      t = canon(t);
      if (!t || STOP[t]) continue;
      rest.push(t);
    }
    return { pieces: pieces, toks: rest, blank: !n };
  }

  function score(p, toks) {
    var total = 0, miss = 0, fz = false;
    toks.forEach(function (q) {
      var best = 0, bm = 0;
      p._f.forEach(function (e) {
        var m = tm(q, e[0], e[2]);
        if (m) { var s = m * e[1]; if (s > best) { best = s; bm = m; } }
      });
      if (!best) miss++; else { total += best; if (bm < 0.8) fz = true; }
    });
    return { s: total, miss: miss, fz: fz };
  }

  function search(q) {
    var P = parse(q), all = cat.products;
    var pool = P.pieces ? all.filter(function (p) { return p.pc === P.pieces; }) : all;
    var out = { list: [], partial: false, fuzzy: false, q: P, generic: false };
    if (!P.toks.length) {
      out.generic = true;
      out.list = pool.map(function (p) { return { p: p, s: 0 }; }).sort(function (a, b) { return (b.p.a ? 1 : 0) - (a.p.a ? 1 : 0) || a.p.o - b.p.o; });
      return out;
    }
    var joined = P.toks.join(' '), res = [], part = [];
    pool.forEach(function (p) {
      var r = score(p, P.toks);
      var bonus = (p._t.indexOf(joined) === 0 ? 25 : (p._t.indexOf(joined) > 0 ? 10 : 0)) + (p.a ? 3 : 0);
      if (r.miss === 0) res.push({ p: p, s: r.s + bonus, fz: r.fz });
      else if (P.toks.length > 1 && r.miss < P.toks.length) part.push({ p: p, s: r.s - r.miss * 50 + bonus });
    });
    function cmp(a, b) { return (b.p.a ? 1 : 0) - (a.p.a ? 1 : 0) || b.s - a.s || a.p.o - b.p.o; }
    if (res.length) {
      res.sort(cmp);
      out.list = res;
      out.fuzzy = res.every(function (r) { return r.fz; });
    } else if (part.length) {
      part.sort(cmp);
      out.list = part; out.partial = true;
    }
    return out;
  }

  function colls(q) {
    var P = parse(q);
    if (!P.toks.length || !cat) return [];
    return cat.collections.filter(function (c) {
      return P.toks.every(function (t) { return t.length >= 2 && c._w.some(function (w) { return tm(t, w, false) >= 0.85; }); });
    });
  }


  /* ---- Site help (added 2026-10-20): the search box is for the whole website, products first.
     A tracking number opens the tracking page with the number filled in; words like size, delivery, exchange, contact point to the right page;
     a search with no results still ends in something useful (quick links and a WhatsApp message that already says what was searched). ---- */
  var WA = '923216173900';
  var ICO = {
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="8" width="20" height="8" rx="1.5"/><path d="M6 8v4M10 8v3M14 8v4M18 8v3"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    swap: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>',
    chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.6 8.6 0 0 1-3.6-.8L3 21l1.9-5.3A8.4 8.4 0 1 1 21 11.5z"/></svg>',
    q: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    doc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M8 13h8M8 17h8"/></svg>'
  };
  var TOPICS = [
    { t: 'Track your order', d: 'See where your parcel is, using the tracking number we sent you on WhatsApp.', u: '/pages/track-order', i: 'pin',
      k: { track: 2, trak: 2, tracking: 2, trace: 2, parcel: 2, courier: 2, shipment: 2, postex: 2, awb: 2, dispatched: 1, status: 1, order: 1, orders: 1, where: 1, delivered: 1 } },
    { t: 'Size chart', d: 'Measurements in inches for S, M, L and XL, and how to pick yours.', u: '/pages/size-chart', i: 'ruler',
      k: { size: 2, sizes: 2, sizing: 2, chart: 2, measurement: 2, measurements: 2, fit: 1, fitting: 1, length: 1, chest: 1, bust: 1, waist: 1, inches: 1 } },
    { t: 'Shipping & delivery', d: 'Nationwide delivery, how long it takes, charges, and Cash on Delivery.', u: '/pages/shipping-delivery', i: 'truck',
      k: { delivery: 2, deliver: 2, shipping: 2, ship: 2, shipped: 1, dispatch: 1, charges: 2, charge: 1, free: 1, cod: 2, cash: 1, payment: 1, pay: 1, arrive: 1, days: 1, nationwide: 1, cities: 1, time: 1 } },
    { t: 'Returns & exchanges', d: 'How exchanges work and how to ask for one.', u: '/pages/returns-exchanges', i: 'swap',
      k: { return: 2, returns: 2, exchange: 2, exchanges: 2, refund: 2, replace: 2, replacement: 2, cancel: 2, cancellation: 2, wrong: 1, damaged: 1, defective: 1, change: 1 } },
    { t: 'Contact us', d: 'Message us on WhatsApp. We reply personally, usually within a few hours.', u: '/pages/contact', i: 'chat',
      k: { contact: 2, whatsapp: 2, call: 1, phone: 1, number: 1, email: 2, mail: 1, support: 2, help: 1, talk: 1, chat: 1, reach: 1, address: 1, location: 1, store: 1, instagram: 1, tiktok: 1, facebook: 1 } },
    { t: 'FAQ', d: 'Answers about ordering, payment, shipping, sizing and exchanges.', u: '/pages/faq', i: 'q',
      k: { faq: 2, faqs: 2, question: 2, questions: 2, how: 1, what: 1, why: 1, when: 1, ask: 1, payment: 1, order: 1, ordering: 1 } },
    { t: 'About Khizra Artstyle', d: 'Our story: drawn first, stitched second.', u: '/pages/about-us', i: 'info',
      k: { about: 2, brand: 2, story: 2, founder: 2, who: 1, khizra: 1, artstyle: 1 } },
    { t: 'Privacy policy', d: 'What we collect and how we look after it.', u: '/pages/privacy-policy', i: 'lock',
      k: { privacy: 2, data: 1, cookies: 2, personal: 1 } },
    { t: 'Terms & conditions', d: 'The terms for using this website and placing an order.', u: '/pages/terms-conditions', i: 'doc',
      k: { terms: 2, conditions: 2, tnc: 2, legal: 1 } }
  ];
  function waUrl(q, msg) {
    return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(msg || ('Hi Khizra Artstyle, I was looking for "' + q + '" on your website.'));
  }
  function keyHit(t, k) {
    if (k[t] !== undefined) return k[t];
    var best = 0, key;
    for (key in k) {
      if (t.length >= 4 && key.length > t.length && key.indexOf(t) === 0) best = Math.max(best, k[key] - 0.25);
      else if (t.length >= 5 && key.length >= 5 && Math.abs(t.length - key.length) <= 2 && lev(t, key) <= (t.length >= 8 ? 2 : 1)) best = Math.max(best, k[key] - 0.25);
    }
    return best;
  }
  /* what, besides styles, this search could be about: a list of {t, d, u, i, primary?} (most relevant first) */
  function help(q) {
    var raw = String(q || '').trim(), flat = raw.replace(/[\s\-]/g, ''), out = [];
    if (!raw) return out;
    if (/^(\+?92|0)3\d{9}$/.test(flat)) {
      return [{ t: 'Contact us', d: 'That looks like a phone number. We are easiest to reach on WhatsApp.', u: waUrl(raw, 'Hi Khizra Artstyle'), i: 'chat', primary: true, cta: 'Open WhatsApp' }];
    }
    if (/^\d{9,20}$/.test(flat)) {
      return [{ t: 'Track this parcel', d: 'This looks like a tracking number. Open it on our tracking page to see where your parcel is.', u: '/pages/track-order?n=' + encodeURIComponent(flat), i: 'pin', primary: true, cta: 'Track ' + flat }];
    }
    if (/^(#|ka-?)\d{3,7}$/i.test(flat) || /^\d{4,8}$/.test(flat)) {
      return [
        { t: 'Looking for an order?', d: 'Orders are tracked with the tracking number we send on WhatsApp. Paste that number on the tracking page.', u: '/pages/track-order', i: 'pin', primary: true, cta: 'Open tracking page' },
        { t: 'Ask us about order ' + raw.replace(/^#/, ''), d: 'We will check it and reply on WhatsApp.', u: waUrl(raw, 'Hi Khizra Artstyle, could you update me on order ' + raw + '?'), i: 'chat' }
      ];
    }
    var toks = norm(raw).split(' ').filter(Boolean), scores = TOPICS.map(function () { return 0; });
    toks.forEach(function (t) {
      TOPICS.forEach(function (tp, n) { scores[n] += keyHit(t, tp.k); });
    });
    TOPICS.forEach(function (tp, n) { if (scores[n] >= 1.5) out.push({ s: scores[n], tp: tp }); });
    out.sort(function (a, b) { return b.s - a.s; });
    return out.map(function (x) { return x.tp; });
  }
  function hesc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function helpHtml(list, max) {
    if (!list || !list.length) return '';
    return '<div class="ps-helps">' + list.slice(0, max || 3).map(function (x) {
      var ext = /^https?:/.test(x.u);
      return '<a class="ps-help' + (x.primary ? ' is-primary' : '') + '" href="' + hesc(x.u) + '"' + (ext ? ' target="_blank" rel="noopener"' : '') + '>' +
        '<span class="ps-help-ico" aria-hidden="true">' + (ICO[x.i] || ICO.info) + '</span>' +
        '<span class="ps-help-txt"><b>' + hesc(x.t) + '</b><small>' + hesc(x.d) + '</small>' + (x.cta ? '<em>' + hesc(x.cta) + '</em>' : '') + '</span>' +
        '<span class="ps-help-go" aria-hidden="true">→</span></a>';
    }).join('') + '</div>';
  }
  /* quick links for a search that found nothing */
  function quickHtml() {
    return '<div class="s-chips ps-quick">' + [['Track your order', '/pages/track-order'], ['Size chart', '/pages/size-chart'], ['Delivery', '/pages/shipping-delivery'], ['Exchanges', '/pages/returns-exchanges']].map(function (x) {
      return '<a class="s-chip" href="' + x[1] + '">' + x[0] + '</a>';
    }).join('') + '</div>';
  }
  function waHtml(q) {
    return '<a class="ps-wa-card" href="' + hesc(waUrl(q)) + '" target="_blank" rel="noopener"><span class="ps-help-ico" aria-hidden="true">' + ICO.chat + '</span><span class="ps-help-txt"><b>Can\'t find it? Ask us on WhatsApp</b><small>We\'ll find the right style for you. Your search is added to the message.</small></span><span class="ps-help-go" aria-hidden="true">→</span></a>';
  }

  window.KhizraSearch = { waUrl: waUrl, help: help, helpHtml: helpHtml, quickHtml: quickHtml, waHtml: waHtml, load: load, search: search, colls: colls, norm: norm, parse: parse, ready: function () { return !!cat; }, catalog: function () { return cat; } };
})();
